import { useContext } from "react";
import { ApplicationDetailContext } from "./ApplicationDetailProvider";

export const useApplicationDetailContext = () => useContext(ApplicationDetailContext);

export default useApplicationDetailContext;
